export default __webpack_public_path__ + "static/media/health2.f6dedb4d.jpg";